'use client';
import Timestamp from 'react-timestamp';
import { Box } from '@components/ui/Box';
import { Paragraph } from '@components/ui/Paragraph';
import { Grid } from '@/src/packages/components/ui/GridBox';
import { Stars } from '@/src/packages/components/ui/Stars';
import { Image } from '@/src/packages/components/ui/Image';
import { IReview } from '@/src/interfaces/generated/contentful';

export const Testimonial = ({ review }: { review: IReview }) => {
  return (
    <Grid>
      <Box as="header" colSpan={{ initial: 12, lg: 4 }}>
        <Box className="space-y-4">
          <Stars />
          <Box className="text-text-secondary text-sm">
            <Timestamp date={review.fields.date} relative />
          </Box>
        </Box>
      </Box>
      <Box colSpan={{ initial: 12, lg: 8 }} as="main">
        <Grid>
          <Box colSpan={{ initial: 12, lg: 8 }}>
            <Paragraph size="default" marginBottom={4}>
              “{review.fields.content}”
            </Paragraph>
            <Box className="font-medium leading-none">
              {review.fields.firstName}
            </Box>
          </Box>
          {review.fields.images && (
            <Box colSpan={{ initial: 12, lg: 4 }}>
              {review.fields.images.map((image, i) => {
                return (
                  <Image
                    key={i}
                    aspectRatio={'1/1'}
                    alt={review.fields.content || ''}
                    fill
                    className="ml-auto h-full shrink-0"
                    sizes="(max-width: 1024px) 100vw, 50vw"
                    src={image.fields.file.url}
                  />
                );
              })}
            </Box>
          )}
        </Grid>
      </Box>
    </Grid>
  );
};
